import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './layout/Header';
import NavBarNew from './layout/Nav';
import Footer from './layout/Footer';
import { useState } from 'react';
import { Route, Routes as Switch, Navigate as Redirect } from 'react-router-dom';
import HomeIndex from './views/home';
import Glossary from './views/glossary';
import VariazioniTerritorio from './views/variazioniTerritorio/index';
import TerritorialUnits from './views/territorialUnits';
import RicercaStoriaUABox from 'views/ricercaStoriaUABox';
import CodificheTerritorialiUABox from 'views/codificheTerritorialiBox';
import CaratteristicheClassificazioniBox from 'views/caratteristicheClassificazioniBox';
import GeografieEuropeeClassificazioni from 'views/geografieEuropeeClassificazioni';
import StoriaUA from 'views/storiaUA';
import { NewDownloadPage } from 'components/NewDownloadPage';
import RicercaCodice from 'views/ricercaCodice';
import RicostruzioneCodici from 'views/ricostruzioneCodici';
import { useDispatch, useSelector } from 'react-redux';
import { updateImpostazioni } from './redux/reducers/Session.reducer';
import IsMobile from 'components/IsMobile/IsMobile';
import TabSkip from 'services/TabSkip/TabSkip';

const App = () => {
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState(false);

  return (
    <>
      <IsMobile />
      <TabSkip /> 
      <Header />
      <NavBarNew />
      <div className="main-div">
        <div>
          <main id="main-content" className={`pb-4 pt-3 pb-4 bs-docs-section clearfix`}>
            <Switch>
              <Route path="/home/*" element={<HomeIndex isMobile={false} />} />
              <Route path="/glossario/*" element={<Glossary isMobile={isMobile} />} exact />
              <Route path="/territorio/*" element={<TerritorialUnits isMobile={isMobile} />} />
              <Route path="/variazioni/*" element={<VariazioniTerritorio />} />
              <Route path="/storia-ua-scopri/*" element={<RicercaStoriaUABox />} />
              <Route
                path="/codifiche-territoriali/*"
                element={<CodificheTerritorialiUABox isMobile={isMobile} />}
              />
              <Route
                path="/caratteristiche-classificazioni/*"
                element={<CaratteristicheClassificazioniBox />}
              />
              <Route
                path="/geo-eu-clas/*"
                element={<GeografieEuropeeClassificazioni isMobile={isMobile} />}
              />
              <Route path="/storia_ua/*" element={<StoriaUA isMobile={isMobile} />} />
              <Route path="/ricerca-codice/*" element={<RicercaCodice isMobile={isMobile} />} />
              {/* FASE 3 - PAGINA DOWNLOAD OSCURATA
              <Route
                path="/download/*"
                element={
                  <>
                    <NewDownloadPage isMobile={isMobile} />
                  </>
                }
              />
              */}
              <Route
                path="/ricostruzione-codici/*"
                element={<RicostruzioneCodici isMobile={isMobile} />}
              />
              <Route path="*" exact={true} element={<Redirect to="/home" />} />
            </Switch>
          </main>
        </div>
      </div>
      <footer id="footer">
        <Footer isMobile={isMobile} />
      </footer>
    </>
  );
};

export default App;
